import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthContext, TokenService } from '@srhk/srhk-core-library';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  appType="";

  public constructor(
    // private analytics: AnalyticsService,
    private router: Router,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private authContext: AuthContext,
    private tokenService: TokenService
  ) {
    
    if (this.authContext.isAuthenticated && this.tokenService.getHomeDashboardURL()) {
      this.router.navigate([this.tokenService.getHomeDashboardURL()]);
    }

    // if (!this.authContext.isAuthenticated ) {
    //   this.tokenService.setHomeDashboardURL('home')
    //   this.router.navigate(['auth/login'], { replaceUrl: true });
    // }
  }

  ngOnInit() {
    // this.analytics.trackPageViews();
  }
}


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/